import classNames from 'classnames'

import { Text } from '../../components'

import { CaptionImageCaption } from './types'

export const Caption = ({ caption, className }: CaptionImageCaption) => (
  <div className={classNames('captioned-image__caption', className)}>
    <Text variant="body-sm" className="font-regular">
      {caption}
    </Text>
  </div>
)
